import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

class RepeatingFormLineItem extends Component {
  handleClick() {
    this.props.onClick(this.props.uuid, this.props.index);
  }

  render() {
    const { title, index } = this.props;

    return (
      <div style={{ paddingBottom: "10px" }}>
        <div
          onClick={this.handleClick.bind(this)}
          style={{ padding: "9.5px" }}
          className="check"
        >
          {title + " " + index}
          <Icon
            type="MaterialIcons"
            className="chevron"
            style={{ float: "right", cursor: "pointer" }}
            size="20"
            name="chevron right"
          />
        </div>
      </div>
    );
  }
}

RepeatingFormLineItem.propTypes = {
  lineItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  storeColour: PropTypes.object.isRequired
};

export default RepeatingFormLineItem;



// WEBPACK FOOTER //
// ./src/components/RepeatingFormLineItem/index.js